import { useCallback } from 'react';
import { useResource } from 'hooks/useResource';
import salesforceAccountsService from 'services/salesforceAccountsService';

const useAccountKPIs = (accountId) => {
	const fetchTotalCommitments = useCallback(async () => {
		if (!accountId) return null;
		return await salesforceAccountsService.getTotalCommitments(accountId);
	}, [accountId]);

	const fetchContributionsToDate = useCallback(async () => {
		if (!accountId) return null;
		return await salesforceAccountsService.getContributionsToDate(accountId);
	}, [accountId]);

	const fetchActivePipeline = useCallback(async () => {
		if (!accountId) return null;
		return await salesforceAccountsService.getActivePipeline(accountId);
	}, [accountId]);

	const fetchLastInteraction = useCallback(async () => {
		if (!accountId) return null;
		return await salesforceAccountsService.getLastInteraction(accountId);
	}, [accountId]);

	const totalCommitments = useResource({ fetchFn: fetchTotalCommitments });
	const contributionsToDate = useResource({ fetchFn: fetchContributionsToDate });
	const activePipeline = useResource({ fetchFn: fetchActivePipeline });
	const lastInteraction = useResource({ fetchFn: fetchLastInteraction });

	return {
		totalCommitments: {
			value: totalCommitments.data?.total_commitments ?? null,
			loading: totalCommitments.loading,
			error: totalCommitments.error,
		},
		contributionsToDate: {
			value: contributionsToDate.data?.contributions_to_date ?? null,
			loading: contributionsToDate.loading,
			error: contributionsToDate.error,
		},
		activePipeline: {
			value: activePipeline.data?.active_pipeline ?? null,
			loading: activePipeline.loading,
			error: activePipeline.error,
		},
		lastInteraction: {
			daysSince: lastInteraction.data?.days_since_last_interaction ?? null,
			date: lastInteraction.data?.last_interaction_date ?? null,
			loading: lastInteraction.loading,
			error: lastInteraction.error,
		},
	};
};

export default useAccountKPIs;
